/* AJA Journal — "Daha fazla yükle"
   Sayfalama linkini AJAX ile çekip kartları mevcut gride ekler.
   JS kapalıysa section içindeki klasik sayfalama linkleri devrede kalır. */

(function () {
  function init(root) {
    if (root.dataset.ajaBound === 'true') return;
    root.dataset.ajaBound = 'true';

    var button = root.querySelector('[data-aja-more]');
    if (!button) return;

    var list = root.querySelector('[data-aja-list]');
    var progress = root.querySelector('[data-aja-progress]');
    var sectionId = root.dataset.sectionId;

    button.addEventListener('click', function () {
      var next = button.dataset.nextUrl;
      if (!next) return;

      button.setAttribute('aria-busy', 'true');
      var idle = button.textContent;
      button.textContent = button.dataset.loadingText || 'Yükleniyor';

      fetch(next)
        .then(function (res) {
          if (!res.ok) throw new Error('AJA Journal: sayfa yüklenemedi');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = doc.querySelector('[data-section-id="' + sectionId + '"]');
          if (!nextRoot) throw new Error('AJA Journal: grid bulunamadı');

          var nextList = nextRoot.querySelector('[data-aja-list]');
          var cards = nextList ? Array.prototype.slice.call(nextList.children) : [];
          cards.forEach(function (card, i) {
            card.style.animationDelay = i * 60 + 'ms';
            list.appendChild(card);
          });

          var nextButton = nextRoot.querySelector('[data-aja-more]');
          if (nextButton && nextButton.dataset.nextUrl) {
            button.dataset.nextUrl = nextButton.dataset.nextUrl;
          } else {
            button.parentNode.removeChild(button);
          }

          if (progress) {
            var shown = list.children.length;
            var total = progress.dataset.total;
            progress.textContent = progress.dataset.template
              .replace('[shown]', shown)
              .replace('[total]', total);
          }

          if (window.history && history.replaceState) {
            history.replaceState(null, '', next);
          }
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          if (button.isConnected) {
            button.setAttribute('aria-busy', 'false');
            button.textContent = idle;
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-aja-journal-grid]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
